/*
 * @Author       : Archer<ahh666@qq.com>
 * @Date         : 2023-06-08 15:49:16
 * @LastEditors  : Archer<ahh666@qq.com>
 * @LastEditTime : 2023-07-17 16:08:09
 * @FilePath     : \youxi\youxi\src\request\imRequest.js
 * @Description  : Description
 */

import axios from "axios";
import { Message } from "element-ui";
import router from "@/router/index";
import { refreshToken } from "./im";

const { VUE_APP_IM_APP_KEY, VUE_APP_IM_API_URL } = process.env;

const baseUrl = VUE_APP_IM_API_URL;
const appkey = VUE_APP_IM_APP_KEY;

let restartFlag = false;
let restartQueue = [];

export class RequestHandler {
  constructor() {
    this.loading = false;
    this.handler = axios.create({
      baseURL: baseUrl + "/api",
      headers: {
        appid: appkey,
        "App-Version": "1.0.1"
      }
    });
    this.handler.interceptors.request.use(config => {
      config.headers.token = localStorage.getItem("TOKEN_FOR_IM") || null;
      if (config.url !== "/user/login") {
        config.headers.http_Vv1 =
          JSON.parse(localStorage.getItem("USER_IM_INFO")).user_id || null;
      }
      return config;
    });
    this.handler.interceptors.response.use(
      async response => {
        const { code, data, message } = response.data;
        const requestUrl = response.config.url;
        if (requestUrl === "/user/refresh_token" && code !== 200) {
          location.href = "/login";
        }
        // 当前请求
        const config = response.config;
        if (code === 20000) {
          restartQueue.push(config);
          if (restartFlag) {
            return Promise.resolve(this.handler(config));
          } else {
            restartFlag = true;
            return await refreshToken({
              token: localStorage.getItem("TOKEN_FOR_IM")
            }).then(res => {
              // 刷新token成功，将最新的token更新到header中，同时保存在localStorage中
              const { token } = res.data;
              localStorage.setItem("TOKEN_FOR_IM", token);
              for (const config of restartQueue) {
                // 重置一下配置
                config.headers["token"] = token;
                // 重试当前请求并返回promise
                return this.handler(config);
              }
              restartQueue = [];
              restartFlag = false;
            });
          }
        }
        code !== 200 &&
          Message({
            type: "error",
            center: true,
            message
          });
        return response.data;
      },
      err => {
        Message({
          type: "error",
          center: true,
          message: "网络不稳定"
        });
      }
    );
  }

  get(url = "", params = {}, config = {}) {
    return this.handler({
      method: "GET",
      url,
      params: {
        ...params,
        now: Date.now()
      },
      ...config
    });
  }

  post(url = "", params = {}, config = {}) {
    return this.handler({
      method: "POST",
      url,
      data: params,
      ...config
    });
  }
}

const request = new RequestHandler();
export const get = request.get.bind(request);
export const post = request.post.bind(request);
